import {getExpedient} from "@project/sdk/sales";
import {GetExpedientResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {expedientKeys} from "../../../expedient-keys";

export function getExpedientQueryOptions(id: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: expedientKeys.detail(id),
    queryFn: async ({signal}) => GetExpedientResponse.parse(await getExpedient(id, {signal})),
  });
}
